import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3frsmupst9pih as Char__compareTo_impl_ypi4mb,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { copyOfwy6h3t5vzqpl as copyOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayIndexOutOfBoundsException3rm3ooo7dx3e8 as ArrayIndexOutOfBoundsException } from '../NonJvmPlatform.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { concatToString3cxf0c1gqonpo as concatToString } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function commonAsUtf8ToByteArray(_this__u8e3s4) {
  var bytes = new Int8Array(imul(4, _this__u8e3s4.length));
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b0 = charCodeAt(_this__u8e3s4, index);
      if (Char__compareTo_impl_ypi4mb(b0, _Char___init__impl__6a9atx(128)) >= 0) {
        var size = index;
        // Inline function 'okio.processUtf8Bytes' call
        var endIndex = _this__u8e3s4.length;
        var index_0 = index;
        while (index_0 < endIndex) {
          var c = charCodeAt(_this__u8e3s4, index_0);
          if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(128)) < 0) {
            // Inline function 'kotlin.code' call
            var tmp$ret$0 = Char__toInt_impl_vasixd(c);
            var c_0 = toByte(tmp$ret$0);
            var tmp0 = size;
            size = tmp0 + 1 | 0;
            bytes[tmp0] = c_0;
            index_0 = index_0 + 1 | 0;
            while (index_0 < endIndex && Char__compareTo_impl_ypi4mb(charCodeAt(_this__u8e3s4, index_0), _Char___init__impl__6a9atx(128)) < 0) {
              var tmp1 = index_0;
              index_0 = tmp1 + 1 | 0;
              // Inline function 'kotlin.code' call
              var this_0 = charCodeAt(_this__u8e3s4, tmp1);
              var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
              var c_1 = toByte(tmp$ret$2);
              var tmp0_0 = size;
              size = tmp0_0 + 1 | 0;
              bytes[tmp0_0] = c_1;
            }
          } else if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(2048)) < 0) {
            // Inline function 'kotlin.code' call
            var tmp$ret$4 = Char__toInt_impl_vasixd(c);
            var c_2 = toByte(tmp$ret$4 >> 6 | 192);
            var tmp0_1 = size;
            size = tmp0_1 + 1 | 0;
            bytes[tmp0_1] = c_2;
            // Inline function 'kotlin.code' call
            var tmp$ret$6 = Char__toInt_impl_vasixd(c);
            var c_3 = toByte(tmp$ret$6 & 63 | 128);
            var tmp0_2 = size;
            size = tmp0_2 + 1 | 0;
            bytes[tmp0_2] = c_3;
            index_0 = index_0 + 1 | 0;
          } else if (!(_Char___init__impl__6a9atx(55296) <= c ? c <= _Char___init__impl__6a9atx(57343) : false)) {
            // Inline function 'kotlin.code' call
            var tmp$ret$8 = Char__toInt_impl_vasixd(c);
            var c_4 = toByte(tmp$ret$8 >> 12 | 224);
            var tmp0_3 = size;
            size = tmp0_3 + 1 | 0;
            bytes[tmp0_3] = c_4;
            // Inline function 'kotlin.code' call
            var tmp$ret$10 = Char__toInt_impl_vasixd(c);
            var c_5 = toByte(tmp$ret$10 >> 6 & 63 | 128);
            var tmp0_4 = size;
            size = tmp0_4 + 1 | 0;
            bytes[tmp0_4] = c_5;
            // Inline function 'kotlin.code' call
            var tmp$ret$12 = Char__toInt_impl_vasixd(c);
            var c_6 = toByte(tmp$ret$12 & 63 | 128);
            var tmp0_5 = size;
            size = tmp0_5 + 1 | 0;
            bytes[tmp0_5] = c_6;
            index_0 = index_0 + 1 | 0;
          } else {
            var tmp;
            if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(56319)) > 0 || endIndex <= (index_0 + 1 | 0)) {
              tmp = true;
            } else {
              var containsArg = charCodeAt(_this__u8e3s4, index_0 + 1 | 0);
              tmp = !(_Char___init__impl__6a9atx(56320) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57343) : false);
            }
            if (tmp) {
              var tmp0_6 = size;
              size = tmp0_6 + 1 | 0;
              bytes[tmp0_6] = 63;
              index_0 = index_0 + 1 | 0;
            } else {
              // Inline function 'kotlin.code' call
              var tmp_0 = Char__toInt_impl_vasixd(c) << 10;
              // Inline function 'kotlin.code' call
              var this_1 = charCodeAt(_this__u8e3s4, index_0 + 1 | 0);
              var codePoint = (tmp_0 + Char__toInt_impl_vasixd(this_1) | 0) + -56613888 | 0;
              var c_7 = toByte(codePoint >> 18 | 240);
              var tmp0_7 = size;
              size = tmp0_7 + 1 | 0;
              bytes[tmp0_7] = c_7;
              var c_8 = toByte(codePoint >> 12 & 63 | 128);
              var tmp0_8 = size;
              size = tmp0_8 + 1 | 0;
              bytes[tmp0_8] = c_8;
              var c_9 = toByte(codePoint >> 6 & 63 | 128);
              var tmp0_9 = size;
              size = tmp0_9 + 1 | 0;
              bytes[tmp0_9] = c_9;
              var c_10 = toByte(codePoint & 63 | 128);
              var tmp0_10 = size;
              size = tmp0_10 + 1 | 0;
              bytes[tmp0_10] = c_10;
              index_0 = index_0 + 2 | 0;
            }
          }
        }
        return copyOf(bytes, size);
      }
      // Inline function 'kotlin.code' call
      var tmp$ret$22 = Char__toInt_impl_vasixd(b0);
      bytes[index] = toByte(tmp$ret$22);
    }
     while (inductionVariable < last);
  return copyOf(bytes, _this__u8e3s4.length);
}
function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
  beginIndex = beginIndex === VOID ? 0 : beginIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
    throw ArrayIndexOutOfBoundsException().j3w('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
  }
  var chars = charArray(endIndex - beginIndex | 0);
  var length = 0;
  // Inline function 'okio.processUtf16Chars' call
  var index = beginIndex;
  while (index < endIndex) {
    var b0 = _this__u8e3s4[index];
    if (b0 >= 0) {
      var c = numberToChar(b0);
      var tmp0 = length;
      length = tmp0 + 1 | 0;
      chars[tmp0] = c;
      index = index + 1 | 0;
      while (index < endIndex && _this__u8e3s4[index] >= 0) {
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var c_0 = numberToChar(_this__u8e3s4[tmp1]);
        var tmp0_0 = length;
        length = tmp0_0 + 1 | 0;
        chars[tmp0_0] = c_0;
      }
    } else {
      // Inline function 'okio.shr' call
      if (b0 >> 5 === -2) {
        var tmp = index;
        var tmp2 = index;
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'okio.process2Utf8Bytes' call
          if (endIndex <= (tmp2 + 1 | 0)) {
            var c_1 = numberToChar(65533);
            var tmp0_1 = length;
            length = tmp0_1 + 1 | 0;
            chars[tmp0_1] = c_1;
            tmp$ret$5 = 1;
            break $l$block_0;
          }
          var b0_0 = _this__u8e3s4[tmp2];
          var b1 = _this__u8e3s4[tmp2 + 1 | 0];
          // Inline function 'okio.isUtf8Continuation' call
          // Inline function 'okio.and' call
          if (!((b1 & 192) === 128)) {
            var c_2 = numberToChar(65533);
            var tmp0_2 = length;
            length = tmp0_2 + 1 | 0;
            chars[tmp0_2] = c_2;
            tmp$ret$5 = 1;
            break $l$block_0;
          }
          var codePoint = 3968 ^ b1 ^ b0_0 << 6;
          if (codePoint < 128) {
            var c_3 = numberToChar(65533);
            var tmp0_3 = length;
            length = tmp0_3 + 1 | 0;
            chars[tmp0_3] = c_3;
          } else {
            var c_4 = numberToChar(codePoint);
            var tmp0_4 = length;
            length = tmp0_4 + 1 | 0;
            chars[tmp0_4] = c_4;
          }
          tmp$ret$5 = 2;
        }
        index = tmp + tmp$ret$5 | 0;
      } else {
        // Inline function 'okio.shr' call
        if (b0 >> 4 === -2) {
          var tmp_0 = index;
          var tmp2_0 = index;
          var tmp$ret$19;
          $l$block_4: {
            // Inline function 'okio.process3Utf8Bytes' call
            if (endIndex <= (tmp2_0 + 2 | 0)) {
              var c_5 = numberToChar(65533);
              var tmp0_5 = length;
              length = tmp0_5 + 1 | 0;
              chars[tmp0_5] = c_5;
              var tmp_1;
              if (endIndex <= (tmp2_0 + 1 | 0)) {
                tmp_1 = true;
              } else {
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                tmp_1 = !((_this__u8e3s4[tmp2_0 + 1 | 0] & 192) === 128);
              }
              if (tmp_1) {
                tmp$ret$19 = 1;
                break $l$block_4;
              } else {
                tmp$ret$19 = 2;
                break $l$block_4;
              }
            }
            var b0_1 = _this__u8e3s4[tmp2_0];
            var b1_0 = _this__u8e3s4[tmp2_0 + 1 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b1_0 & 192) === 128)) {
              var c_6 = numberToChar(65533);
              var tmp0_6 = length;
              length = tmp0_6 + 1 | 0;
              chars[tmp0_6] = c_6;
              tmp$ret$19 = 1;
              break $l$block_4;
            }
            var b2 = _this__u8e3s4[tmp2_0 + 2 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b2 & 192) === 128)) {
              var c_7 = numberToChar(65533);
              var tmp0_7 = length;
              length = tmp0_7 + 1 | 0;
              chars[tmp0_7] = c_7;
              tmp$ret$19 = 2;
              break $l$block_4;
            }
            var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
            if (codePoint_0 < 2048) {
              var c_8 = numberToChar(65533);
              var tmp0_8 = length;
              length = tmp0_8 + 1 | 0;
              chars[tmp0_8] = c_8;
            } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
              var c_9 = numberToChar(65533);
              var tmp0_9 = length;
              length = tmp0_9 + 1 | 0;
              chars[tmp0_9] = c_9;
            } else {
              var c_10 = numberToChar(codePoint_0);
              var tmp0_10 = length;
              length = tmp0_10 + 1 | 0;
              chars[tmp0_10] = c_10;
            }
            tmp$ret$19 = 3;
          }
          index = tmp_0 + tmp$ret$19 | 0;
        } else {
          // Inline function 'okio.shr' call
          if (b0 >> 3 === -2) {
            var tmp_2 = index;
            var tmp2_1 = index;
            var tmp$ret$41;
            $l$block_10: {
              // Inline function 'okio.process4Utf8Bytes' call
              if (endIndex <= (tmp2_1 + 3 | 0)) {
                if (!(65533 === 65533)) {
                  var c_11 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_11 = length;
                  length = tmp0_11 + 1 | 0;
                  chars[tmp0_11] = c_11;
                  var c_12 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_12 = length;
                  length = tmp0_12 + 1 | 0;
                  chars[tmp0_12] = c_12;
                } else {
                  var c_13 = _Char___init__impl__6a9atx(65533);
                  var tmp0_13 = length;
                  length = tmp0_13 + 1 | 0;
                  chars[tmp0_13] = c_13;
                }
                var tmp_3;
                if (endIndex <= (tmp2_1 + 1 | 0)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'okio.isUtf8Continuation' call
                  // Inline function 'okio.and' call
                  tmp_3 = !((_this__u8e3s4[tmp2_1 + 1 | 0] & 192) === 128);
                }
                if (tmp_3) {
                  tmp$ret$41 = 1;
                  break $l$block_10;
                } else {
                  var tmp_4;
                  if (endIndex <= (tmp2_1 + 2 | 0)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'okio.isUtf8Continuation' call
                    // Inline function 'okio.and' call
                    tmp_4 = !((_this__u8e3s4[tmp2_1 + 2 | 0] & 192) === 128);
                  }
                  if (tmp_4) {
                    tmp$ret$41 = 2;
                    break $l$block_10;
                  } else {
                    tmp$ret$41 = 3;
                    break $l$block_10;
                  }
                }
              }
              var b0_2 = _this__u8e3s4[tmp2_1];
              var b1_1 = _this__u8e3s4[tmp2_1 + 1 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b1_1 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_14 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_14 = length;
                  length = tmp0_14 + 1 | 0;
                  chars[tmp0_14] = c_14;
                  var c_15 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_15 = length;
                  length = tmp0_15 + 1 | 0;
                  chars[tmp0_15] = c_15;
                } else {
                  var c_16 = _Char___init__impl__6a9atx(65533);
                  var tmp0_16 = length;
                  length = tmp0_16 + 1 | 0;
                  chars[tmp0_16] = c_16;
                }
                tmp$ret$41 = 1;
                break $l$block_10;
              }
              var b2_0 = _this__u8e3s4[tmp2_1 + 2 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b2_0 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_17 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_17 = length;
                  length = tmp0_17 + 1 | 0;
                  chars[tmp0_17] = c_17;
                  var c_18 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_18 = length;
                  length = tmp0_18 + 1 | 0;
                  chars[tmp0_18] = c_18;
                } else {
                  var c_19 = _Char___init__impl__6a9atx(65533);
                  var tmp0_19 = length;
                  length = tmp0_19 + 1 | 0;
                  chars[tmp0_19] = c_19;
                }
                tmp$ret$41 = 2;
                break $l$block_10;
              }
              var b3 = _this__u8e3s4[tmp2_1 + 3 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b3 & 192) === 128)) {
                if (!(65533 === 65533)) {
                  var c_20 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_20 = length;
                  length = tmp0_20 + 1 | 0;
                  chars[tmp0_20] = c_20;
                  var c_21 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_21 = length;
                  length = tmp0_21 + 1 | 0;
                  chars[tmp0_21] = c_21;
                } else {
                  var c_22 = _Char___init__impl__6a9atx(65533);
                  var tmp0_22 = length;
                  length = tmp0_22 + 1 | 0;
                  chars[tmp0_22] = c_22;
                }
                tmp$ret$41 = 3;
                break $l$block_10;
              }
              var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
              if (codePoint_1 > 1114111) {
                if (!(65533 === 65533)) {
                  var c_23 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_23 = length;
                  length = tmp0_23 + 1 | 0;
                  chars[tmp0_23] = c_23;
                  var c_24 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_24 = length;
                  length = tmp0_24 + 1 | 0;
                  chars[tmp0_24] = c_24;
                } else {
                  var c_25 = _Char___init__impl__6a9atx(65533);
                  var tmp0_25 = length;
                  length = tmp0_25 + 1 | 0;
                  chars[tmp0_25] = c_25;
                }
              } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                if (!(65533 === 65533)) {
                  var c_26 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_26 = length;
                  length = tmp0_26 + 1 | 0;
                  chars[tmp0_26] = c_26;
                  var c_27 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_27 = length;
                  length = tmp0_27 + 1 | 0;
                  chars[tmp0_27] = c_27;
                } else {
                  var c_28 = _Char___init__impl__6a9atx(65533);
                  var tmp0_28 = length;
                  length = tmp0_28 + 1 | 0;
                  chars[tmp0_28] = c_28;
                }
              } else if (codePoint_1 < 65536) {
                if (!(65533 === 65533)) {
                  var c_29 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  var tmp0_29 = length;
                  length = tmp0_29 + 1 | 0;
                  chars[tmp0_29] = c_29;
                  var c_30 = numberToChar((65533 & 1023) + 56320 | 0);
                  var tmp0_30 = length;
                  length = tmp0_30 + 1 | 0;
                  chars[tmp0_30] = c_30;
                } else {
                  var c_31 = _Char___init__impl__6a9atx(65533);
                  var tmp0_31 = length;
                  length = tmp0_31 + 1 | 0;
                  chars[tmp0_31] = c_31;
                }
              } else {
                if (!(codePoint_1 === 65533)) {
                  var c_32 = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                  var tmp0_32 = length;
                  length = tmp0_32 + 1 | 0;
                  chars[tmp0_32] = c_32;
                  var c_33 = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                  var tmp0_33 = length;
                  length = tmp0_33 + 1 | 0;
                  chars[tmp0_33] = c_33;
                } else {
                  var c_34 = _Char___init__impl__6a9atx(65533);
                  var tmp0_34 = length;
                  length = tmp0_34 + 1 | 0;
                  chars[tmp0_34] = c_34;
                }
              }
              tmp$ret$41 = 4;
            }
            index = tmp_2 + tmp$ret$41 | 0;
          } else {
            var c_35 = _Char___init__impl__6a9atx(65533);
            var tmp0_35 = length;
            length = tmp0_35 + 1 | 0;
            chars[tmp0_35] = c_35;
            index = index + 1 | 0;
          }
        }
      }
    }
  }
  return concatToString(chars, 0, length);
}
//region block: exports
export {
  commonAsUtf8ToByteArray as commonAsUtf8ToByteArray20rkxdpc9aw5b,
  commonToUtf8String as commonToUtf8Stringyih6e1qg1yoo,
};
//endregion

//# sourceMappingURL=-Utf8.mjs.map
